// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserTaggingPingBodyStyles-cls1___e034abcd2cf5f227f98{/*!*/}.UserTaggingPingBodyStyles-cls2___515ad90ba33eb0ea42d{font-weight:500;font-size:14px;line-height:16px;letter-spacing:.1em;margin-bottom:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "UserTaggingPingBodyStyles-cls1___e034abcd2cf5f227f98",
	"cls2": "UserTaggingPingBodyStyles-cls2___515ad90ba33eb0ea42d UserTaggingPingBodyStyles-cls1___e034abcd2cf5f227f98"
};
export default ___CSS_LOADER_EXPORT___;
